import gql from 'graphql-tag';

const UPDATE_CAMPAIGN_STATUS = gql`
  mutation updateCampaignStatus($where: CampaignWhereUniqueInput!, $data: CampaignUpdateInput!) {
    updateCampaign(where: $where, data: $data) {
      id
      status
      demandSidePlatform
      adProviderId
      maxBid
      isLaunchProgrammatically

      # Flight schedules
      flightSchedules {
        id
        startDate
        endDate
        budget
        cpm
        createdAt
        updatedAt
      }
    }
  }
`;

export default UPDATE_CAMPAIGN_STATUS;
